/**
 * The per-field lines a 400 carries under its headline, when it has any.
 *
 * `ApiRequestError.details` is `unknown` because an `AppError` can attach
 * anything to it, so this reads defensively and returns NOTHING rather than
 * guessing at a shape it does not recognise. What it does recognise is the
 * array the API's Zod handler sends — `{ path, message }` per issue — which is
 * where the actual reason lives: the headline for every one of those is the
 * same "Request validation failed", and dropping the details left an operator
 * with a refusal that named no field at all (2026-09-24).
 */
export function errorDetailLines(error: unknown): string[] {
  const details = (error as { details?: unknown } | null)?.details;
  if (!Array.isArray(details)) return [];
  const lines: string[] = [];
  for (const entry of details) {
    if (!entry || typeof entry !== 'object') continue;
    const { path, message } = entry as { path?: unknown; message?: unknown };
    if (typeof message !== 'string' || !message.trim()) continue;
    // The path is the form's own field name; it is a hint, not a sentence.
    lines.push(typeof path === 'string' && path ? `${path}: ${message}` : message);
  }
  return lines;
}
